import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class SystemReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: false
    };
  };
  /*
   componentDidMount() {
     this.setState({ load: true }, ()=>{
       this.props.loadSystemReview().then((load) => {
         this.setState({ load: load },()=>{
             console.log("cargar revisión del sistema !!");
         });
       }).catch((error)=>{
         console.log(error)
       });
     })
     
   }*/
  componentDidMount() {
    console.log(this.props);
  }

  render() {

    return (
      <Fragment>
        <Col md={12} sm={12}>
          <div className={"container-wraper-hc"}>
            <div className="title-clinic-history">
              <h4>Revisión por Sistema</h4>
            </div>
            <div className="form">
              {this.props.ailments.map((ailment, index) => {
                return (<div key={index} style={{ width: '100%', margin: '1em 0em', display: 'flex' }}>
                  <span className="common-label-section-others" style={{ marginRight: 10, width: 150 }}>{ailment.ailment}</span>
                  <div className="form__form-group-field">
                    <textarea
                      key={`comment-${ailment.ailment}`}
                      name={`comment-${ailment.ailment}`}
                      defaultValue={ailment.commentary}
                      disabled={this.props.isCloseClinicHistory}
                      onChange={(e) => { this.props.handlerCommentsSystemReview(e.target.value, index) }}
                    >
                    </textarea>
                  </div>
                </div>)
              })}
            </div>

          </div>
        </Col>
      </Fragment>
    )
  }
}

export default reduxForm({
  form: `system-review-form`, // a unique identifier for this form
})(withTranslation('common')(SystemReview));